import thumbnailsModule from "../thumbnailsModule";

function twoDThumbnailController (thumbnailConstants, thumbnailService) {
    "ngInject";

    var ctrl = this;
    var lastThumbnail = "";

    ctrl.getCssClasses = function () {
        return {
            "icon-error": ctrl.thumbnailState === thumbnailConstants.thumbnailStates.error,
            "icon-in-review": ctrl.thumbnailState === thumbnailConstants.thumbnailStates.inReview,
            "icon-blocked": ctrl.thumbnailState === thumbnailConstants.thumbnailStates.blocked,
            "icon-pending": ctrl.thumbnailState === thumbnailConstants.thumbnailStates.pending
        };
    };

    var init = function () {
        var requestSize = thumbnailService.getRequestSize(ctrl.size);
        var debounceKey = ctrl.thumbnailType + ":" + ctrl.thumbnailTargetId + ":" + requestSize;

        if (lastThumbnail === debounceKey) {
            return;
        }

        lastThumbnail = debounceKey;
        ctrl.thumbnailState = thumbnailConstants.thumbnailStates.pending;

        thumbnailService.getThumbnailImage(ctrl.thumbnailType, ctrl.thumbnailTargetId, requestSize).then(function (image) {
            ctrl.thumbnailState = image.state;
            ctrl.thumbnailUrl = image.imageUrl;
        }, function () {
            ctrl.thumbnailState = thumbnailConstants.thumbnailStates.error;
        });
    };

    ctrl.$onInit = init;
    ctrl.$onChanges = init;
}

thumbnailsModule
    .controller('2dThumbnailController', twoDThumbnailController);

export default twoDThumbnailController;